import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["title"];
import styled from 'styled-components';
import { CALYPSO, GREAT_WHITE } from 'HubStyleTokens/colors';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledNavItem = styled(UISideNavItem).withConfig({
  displayName: "TranslateTemplateNavItem__StyledNavItem",
  componentId: "sc-11ry3du-0"
})(["border-top:1px solid ", ";padding:16px 28px;"], GREAT_WHITE);
const NavItemTitle = styled.span.withConfig({
  displayName: "TranslateTemplateNavItem__NavItemTitle",
  componentId: "sc-11ry3du-1"
})(["font-size:16px;"]);
export default function TranslateTemplateNavItem(props) {
  const {
      title
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(StyledNavItem, Object.assign({}, rest, {
    title: /*#__PURE__*/_jsx(NavItemTitle, {
      children: title
    }),
    iconRight: /*#__PURE__*/_jsx(UIIcon, {
      name: "right",
      size: 18,
      color: CALYPSO
    })
  }));
}